import { banen } from "./banen";
import { beheer } from "./beheer";
import { common } from "./common";
import { jurylijst } from "./jurylijst";
import { session } from "./session";
import { synchronisaties } from "./synchronisaties";

export const nl = { banen, beheer, common, jurylijst, session, synchronisaties } as const;
